$(document).ready(function() {
    $('.exec-content-page .fold').click(function() {
        var parent = $(this).parent();
        if (parent.hasClass('-is-open')) {
            parent.removeClass('-is-open');
        } else {
            parent.addClass('-is-open');
        }
    });
});